// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItemModal-cls1_h19","cls2":"CreateSocialItemModal-cls2_a_x CreateSocialItemModal-cls1_h19"};